// @flow
import defaultState from '../defaultState';
import type { CurrentShapeSetState as State } from '../types';

const defaultCurrentShapeSet = defaultState.currentShapeSet;

type Action = { type: 'UPDATE_CURRENT_SHAPESET', shapeSet: Object };

export default function currentShapeSet(
  state: State = defaultCurrentShapeSet,
  action: Action
) {
  switch (action.type) {
    case 'UPDATE_CURRENT_SHAPESET':
      return {
        ...defaultCurrentShapeSet,
        ...action.shapeSet.shapeSet,
        settings: action.shapeSet.settings
      };

    // $FlowFixMe
    case 'UPDATE_CURRENT_SHAPESET_SETTINGS':
      return {
        ...state,
        settings: action.settings
      };

    // $FlowFixMe
    case 'UPDATE_CURRENT_SHAPESET_DOWNLOAD_URL':
      return {
        ...state,
        downloadUrl: action.url
      };

    // $FlowFixMe
    case 'UPDATE_CURRENT_SHAPESET_ALLOCATED_INDUSTRIES':
      return {
        ...state,
        industries: {
          ...state.industries,
          allocated: action.industries
        }
      };

    // $FlowFixMe
    case 'UPDATE_CURRENT_SHAPESET_UNALLOCATED_INDUSTRIES':
      return {
        ...state,
        industries: {
          ...state.industries,
          unallocated: action.industries
        }
      };

    // $FlowFixMe
    case 'UPDATE_CURRENT_SHAPESET_ALLOCATED_ORGANISATIONS':
      return {
        ...state,
        organisations: {
          ...state.organisations,
          allocated: action.organisations
        }
      };

    // $FlowFixMe
    case 'UPDATE_CURRENT_SHAPESET_UNALLOCATED_ORGANISATIONS':
      return {
        ...state,
        organisations: {
          ...state.organisations,
          unallocated: action.organisations
        }
      };

    // $FlowFixMe
    case 'CLEAR_CURRENT_SHAPESET':
      return defaultCurrentShapeSet;

    // $FlowFixMe
    case 'LOGOUT':
      return defaultCurrentShapeSet;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/currentShapeSet.js